<template>
  <v-row>
    <v-col>
      <v-card class="py-6" :class="{ 'px-12': $vuetify.breakpoint.smAndUp }">
        <!-- px-6 -->
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="auto">
              <v-menu
                v-model="startDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="$dateFormatByLang(form.StartDate)"
                    label="ตั้งแต่วันที่"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details="auto"
                    dense
                    v-on="on"
                    @click:append="startDateDialog = true"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :locale="$lang === 'Tha' ? 'th' : 'en'"
                  v-model="form.StartDate"
                  @input="startDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="auto">
              <v-menu
                v-model="endDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="$dateFormatByLang(form.EndDate)"
                    label="ถึงวันที่"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details="auto"
                    dense
                    v-on="on"
                    @click:append="endDateDialog = true"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :locale="$lang === 'Tha' ? 'th' : 'en'"
                  v-model="form.EndDate"
                  @input="endDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row v-if="searchValidate" align="center">
            <v-col>
              <span class="error--text">*กรุณาใส่ช่วงเวลาให้ครบถ้วน</span>
            </v-col>
          </v-row>
          <v-row v-if="searchValidate2" align="center">
            <v-col>
              <span class="error--text">*เวลาเริ่มต้นน้อยกว่าเวลาสิ้นสุด</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="auto">
              <v-btn
                @click="onSearch"
                color="primary darken-2"
                depressed
                large
                :disabled="searchValidate || searchValidate2"
              >
                ค้นหา
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="onClear" color="secondary" depressed>
                ล้าง
              </v-btn>
            </v-col>
            <v-col></v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// import ReqCardTable from '@/components/reqcard/ReqCardTable.vue'
export default {
  data() {
    return {
      form: {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10)
      },
      startDateDialog: false,
      endDateDialog: false,
      formValidate: null
    };
  },

  computed: {
    searchValidate() {
      return !(
        (this.form.StartDate === '' && this.form.EndDate === '') ||
        (this.form.StartDate !== '' && this.form.EndDate !== '')
      );
    },
    searchValidate2() {
      return Date.parse(this.form.StartDate) > Date.parse(this.form.EndDate);
    }
  },

  async mounted() {
    await this.setForm();
  },

  methods: {
    resetForm() {
      this.$router.replace({ query: null }).catch(() => {
        console.log('same page, same result');
      });
      this.form = {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10)
      };
    },

    onSearch() {
      this.$router.push({ query: this.form }).catch(() => {
        console.log('same page, same result');
      });
    },

    onClear() {
      this.resetForm();
    },

    setForm() {
      this.form = { ...this.form, ...this.$route.query };
    }
  }
};
</script>
